import { render, staticRenderFns } from "./VrstaSudionikaCreate.vue?vue&type=template&id=0f6694bc&scoped=true&"
import script from "./VrstaSudionikaCreate.vue?vue&type=script&lang=js&"
export * from "./VrstaSudionikaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6694bc",
  null
  
)

export default component.exports